import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=3345e0fe&scoped=true&"
import script from "./ServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=3345e0fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345e0fe",
  null
  
)

export default component.exports